<template>
    <v-card class="announcement-card mb-3 rounded-lg" :class="{'unread': !message.is_read}" elevation="1">
        <div class="type-stripe" :style="{background: typeColor}"/>
        <v-card-text class="pa-3">
            <div class="d-flex align-start justify-space-between ga-2">
                <div class="d-flex align-center ga-2 flex-wrap">
                    <v-chip :color="typeColor" size="x-small" variant="tonal" label>
                        {{ typeLabel }}
                    </v-chip>
                    <v-icon v-if="!message.is_read" color="primary" size="8">mdi-circle</v-icon>
                </div>
                <v-btn icon size="x-small" variant="text" @click.stop="$emit('dismiss', message.id)">
                    <v-icon size="14">mdi-close</v-icon>
                </v-btn>
            </div>
            <div class="mt-2 font-weight-medium text-body-2">{{ message.title }}</div>
            <div class="text-body-2 text-medium-emphasis mt-1 message-body">{{ message.body }}</div>
            <v-img v-if="message.image_url" :src="message.image_url" class="mt-2 rounded"
                   max-height="160" cover/>
            <div v-if="message.cta_url" class="mt-2">
                <v-btn :href="message.cta_url" target="_blank" rel="noopener" color="primary"
                       size="x-small" variant="tonal" @click.stop="$emit('dismiss', message.id)">
                    {{ message.cta_label || 'Learn More' }}
                    <v-icon end size="12">mdi-open-in-new</v-icon>
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script setup>
import {computed} from 'vue';

const props = defineProps({
    message: {type: Object, required: true},
});
defineEmits(['dismiss']);

const TYPE_CONFIG = {
    offer: {label: 'Offer', color: '#F59E0B'},
    tip: {label: 'Tip', color: '#3B82F6'},
    feature: {label: 'New Feature', color: '#7C3AED'},
    announcement: {label: 'Announcement', color: '#0D9488'},
};

const typeColor = computed(() => TYPE_CONFIG[props.message.type]?.color ?? '#6B7280');
const typeLabel = computed(() => TYPE_CONFIG[props.message.type]?.label ?? 'Message');
</script>

<style scoped>
.announcement-card {
    position: relative;
    padding-left: 4px;
    overflow: visible;
    transition: box-shadow 0.2s;
}

.announcement-card.unread {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
}

.type-stripe {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    border-radius: 8px 0 0 8px;
}

.message-body {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
